export const supportedSubjectTypes = [
    'ApplicationRole',
    'AzureLicense',
    'AzureRole',
    'BusinessRole',
    'ManagementRole',
    'Person',
]

export const itShopSupportedResourceTypes = [
    'ApplicationRole',
    'AzureLicense',
    'AzureRole',
    'BusinessRole',
    'ManagementRole',
]
